import {
  SLIDE_IN_FROM_LEFT,
  SLIDE_IN_FROM_RIGHT,
  SLIDE_OUT_TO_LEFT,
  SLIDE_OUT_TO_RIGHT
} from '../keyframes';

type Position = 'left' | 'right';

export function getSlideAnimations(position: Position, isVisible: boolean) {
  const slideIn =
    position === 'right' ? SLIDE_IN_FROM_RIGHT : SLIDE_IN_FROM_LEFT;
  const slideOut =
    position === 'right' ? SLIDE_OUT_TO_RIGHT : SLIDE_OUT_TO_LEFT;

  return isVisible ? slideIn : slideOut;
}
